import { atomWithReset } from 'jotai/utils';

const pageTitleAtom = atomWithReset<string | undefined>(undefined);

export default pageTitleAtom;
